import {
  ApplicationService,
  type GetApplicationApiTenantApplicationsResponse,
} from '@kp/rest-api-javascript-sdk';

/**
 * Whether users of the current tenant can sign in to an application, and
 * the URL of its public authorization (`null` for whitelisted clients,
 * unavailable ones and authorizations without a URL).
 */
export type TenantApplication =
  GetApplicationApiTenantApplicationsResponse['data'][number];

/**
 * Tell for each client whether users of the token's tenant can sign in with
 * it, in the order of `clientIds`.
 *
 * @param clientIds  The Keycloak client ids of the applications
 */
export const getTenantApplications = (clientIds: string[]) =>
  ApplicationService.getTenantApplications({ query: { clientIds } });
